import { useEffect, useState } from "react";
import { Box, Paper, Stack, Typography } from "@mui/material";
import MainButton from "src/components/buttons/mainbutton";
import SecondaryButton from "src/components/buttons/secondbutton";
import {
  AnalyticsConsent,
  applyAnalyticsConsent,
  capturePostHogPageView,
  getAnalyticsConsent,
  initializePostHogIfConsented,
  setAnalyticsConsent,
} from "src/analytics/posthog";
import { textStyle } from "src/styles/textstyle";

export default function AnalyticsConsentManager() {
  const [consent, setConsent] = useState<AnalyticsConsent>(getAnalyticsConsent());
  const [isPreferencesOpen, setIsPreferencesOpen] = useState(
    consent === "unset",
  );

  useEffect(() => {
    applyAnalyticsConsent(consent);

    if (consent === "granted") {
      const initialized = initializePostHogIfConsented(consent);
      if (initialized) {
        capturePostHogPageView(window.location.href);
      }
    }
  }, [consent]);

  const saveConsent = (value: "granted" | "denied") => {
    setAnalyticsConsent(value);
    setConsent(value);
    setIsPreferencesOpen(false);
  };

  return (
    <>
      {isPreferencesOpen ? (
        <Paper
          elevation={8}
          sx={{
            position: "fixed",
            bottom: { xs: 12, sm: 20 },
            left: { xs: 12, sm: "50%" },
            right: { xs: 12, sm: "auto" },
            transform: { xs: "none", sm: "translateX(-50%)" },
            width: { xs: "auto", sm: "min(640px, calc(100vw - 32px))" },
            zIndex: 1400,
            p: { xs: 2, sm: 2.5 },
            borderRadius: 3,
          }}
        >
          <Stack spacing={1.5}>
            <Typography variant="h6" sx={{ fontWeight: 700 }}>
              Privacy settings
            </Typography>
            <Typography
              variant="body2"
              sx={{
                ...textStyle,
                color: "text.secondary",
              }}
            >
              We always count anonymous page visits to keep the service reliable.
              Optional analytics cookies help us understand deeper product usage.
            </Typography>
            <Box
              sx={{
                display: "flex",
                gap: 1,
                flexWrap: "wrap",
                justifyContent: "flex-end",
              }}
            >
              <SecondaryButton
                onClick={() => saveConsent("denied")}
                text="Keep only anonymous visits"
                sx={{ alignSelf: "unset" }}
              />
              <MainButton
                onClick={() => saveConsent("granted")}
                text="Allow analytics cookies"
                sx={{ alignSelf: "unset" }}
              />
            </Box>
          </Stack>
        </Paper>
      ) : (
        <SecondaryButton
          onClick={() => setIsPreferencesOpen(true)}
          text="Privacy settings"
          sx={{
            position: "fixed",
            bottom: 12,
            left: 12,
            zIndex: 1300,
            backgroundColor: "rgba(255,255,255,0.95)",
            borderRadius: 1,
            border: "1px solid rgba(0,0,0,0.12)",
            padding: "4px 10px",
            minWidth: "unset",
          }}
        />
      )}
    </>
  );
}
